export function getAssigneeName(assignee) {
  if (!assignee || !assignee.text) {
    return 'Assignee'
  }
  return assignee.text
}
